import { IconLock } from '@tabler/icons-react';
import { SyncMode } from '../types';
import classes from './ModelList.module.css';

/**
 * Whether a model follows the client's profile. Live picks up profile changes each time
 * the model is opened; frozen keeps the figures it was built with. Blue is kept for this
 * alone, so it never reads as an outcome or an action.
 */
export function SyncStatus({ mode }: { mode: SyncMode }) {
  return (
    <span className={classes.syncStatus} data-mode={mode} data-testid="model-sync-status">
      {mode === 'live' ? (
        <span className={classes.liveDot} aria-hidden />
      ) : (
        <IconLock size={12} stroke={2} aria-hidden />
      )}
      {mode === 'live' ? 'Live' : 'Frozen'}
    </span>
  );
}
